import { UserResponseDto } from '@hello-hola/shared-schema';
import { KyInstance } from 'ky';

export class UserService {
    constructor(private readonly apiClient: KyInstance) { }

    getUser = async (id: number): Promise<UserResponseDto> => {
        return this.apiClient.get(`user/${id}`).json();
    }

    getMe = async (): Promise<UserResponseDto | undefined> => {
        try {
            const res = await this.apiClient.get('user/me');

            if (!res.ok) {
                return;
            }

            return res.json();
        } catch (error) {
            console.error('Error fetching user data:', error);
            return;
        }
    };

    getUserLanguageCount = async (userId: number): Promise<number | undefined> => {
        try {
            const res = await this.apiClient.get(`user-language/${userId}/language/count`);

            if (!res.ok) {
                return;
            }

            return res.json();
        } catch (error) {
            console.error('Error fetching user data:', error);
            return;
        }
    };
}
